import { Component, Renderer, ElementRef } from '@angular/core';
import { PopoverEditableIdNameDropdownComponent } from './popover-editable-id-name-dropdown.component';
import { AddressTypeService } from '../../_services';

@Component({
 
    selector: 'address-type-template-dropdown',
    template:  require('./popover-editable-dropdown.base.template.html')
})
export class AddressTypeTemplateDropdownComponent extends PopoverEditableIdNameDropdownComponent {
    constructor(
        private addressTypeService: AddressTypeService,
        protected renderer: Renderer,
        protected element: ElementRef) {
        super(renderer, element);
    }

    protected getItems(): Promise<number[]> {
        return this.addressTypeService.templates.then(result => {
            this.dropdownItems = result;
            return this.dropdownItems.map(r => r.id);
        });

    }
    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/address-type-template-dropdown.component.ts